import { render, staticRenderFns } from "./AddTeamModal.vue?vue&type=template&id=8a2c8b84&scoped=true&"
import script from "./AddTeamModal.vue?vue&type=script&lang=js&"
export * from "./AddTeamModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTeamModal.vue?vue&type=style&index=0&id=8a2c8b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2c8b84",
  null
  
)

export default component.exports